/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index icon to autogenerate all the components and extensions
 * Used by "prepareIcons"
 */

import Icon from './icon/Icon'
export * from './icon/Icon'
export default Icon
